export const LDM_HEADING = 'Introducing Low Data Mode';
export const LDM_SUBHEADING = 'Save your internet data by switching to low data mode.';
export const LDM_RATING = 'Rate your Low Data Mode Experience';
export const LOW_DATA_MODE_SWITCH_COUNT = 'lowDataModeSwitchCount';
export enum ANCHOR {
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
}

export enum LinkType {
  THREE_D_MODEL,
  URL,
  UNKNOWN,
}

export enum WhiteboardType {
  PEN_TAP = 'PEN_TAP',
  SMART_BOARD = 'SMART_BOARD',
}
